import _slicedToArray from "/Users/mac/dev/larcade/ddl-front/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { CheckIcon, InfoIcon, WarningIcon } from "./chunk-R7JICMEA.mjs";

// src/alert-context.ts
import { createContext } from "@chakra-ui/react-context";
import { Spinner } from "@chakra-ui/spinner";
var _createContext = createContext({
    name: "AlertContext",
    hookName: "useAlertContext",
    providerName: "<Alert />"
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  AlertProvider = _createContext2[0],
  useAlertContext = _createContext2[1];
var _createContext3 = createContext({
    name: "AlertStylesContext",
    hookName: "useAlertStyles",
    providerName: "<Alert />"
  }),
  _createContext4 = _slicedToArray(_createContext3, 2),
  AlertStylesProvider = _createContext4[0],
  useAlertStyles = _createContext4[1];
var STATUSES = {
  info: {
    icon: InfoIcon,
    colorScheme: "blue"
  },
  warning: {
    icon: WarningIcon,
    colorScheme: "orange"
  },
  success: {
    icon: CheckIcon,
    colorScheme: "green"
  },
  error: {
    icon: WarningIcon,
    colorScheme: "red"
  },
  loading: {
    icon: Spinner,
    colorScheme: "blue"
  }
};
function getStatusColorScheme(status) {
  return STATUSES[status].colorScheme;
}
function getStatusIcon(status) {
  return STATUSES[status].icon;
}
export { AlertProvider, useAlertContext, AlertStylesProvider, useAlertStyles, getStatusColorScheme, getStatusIcon };